import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { Image } from '@/libraries/design/components/image/src/image';

import { teamNavigationConfig, teamTabs, type TeamTabValue } from '../jsm-portal-playground-data';

import { JsmPlaygroundNavigation } from './jsm-playground-navigation';

const staticScreenUrls: Record<TeamTabValue, string> = {
	'it-support':
		'https://dam-cdn.atl.orangelogic.com/AssetLink/x0s66n055p312i8y4w0153a4tb2yc22t.png',
	'it-operations':
		'https://dam-cdn.atl.orangelogic.com/AssetLink/jh44qvmk0s53hwx82c3n7sts30kvs8yt.png',
	engineering: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b0ojm3mywvr6326u13mg87fgrt8g2d74.png',
	hr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gvtrqkjkytb1ed5w27xftktdqcol5qvc.png',
};

type JsmPlaygroundStaticScreenProps = {
	team: TeamTabValue;
};

export const JsmPlaygroundStaticScreen = ({ team }: JsmPlaygroundStaticScreenProps) => {
	const intl = useIntl();
	const teamTab = teamTabs.find(({ value }) => value === team);

	return (
		<div css={staticScreenStyles} data-testid={`jsm-playground-static-screen-${team}`}>
			<JsmPlaygroundNavigation
				config={teamNavigationConfig[team]}
				teamName={teamTab ? intl.formatMessage(teamTab.label) : ''}
			/>
			<Image css={screenImageStyles} src={staticScreenUrls[team]} alt="" />
		</div>
	);
};

const staticScreenStyles = css({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	height: '100%',
	borderRadius: token('radius.xlarge'),
	overflow: 'hidden',
});

const screenImageStyles = css({
	display: 'block',
	flex: '1 1 auto',
	width: '100%',
	minHeight: 0,
	objectFit: 'cover',
	objectPosition: 'top center',
});
